import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Chart, Point } from "chart.js";
import { Observable, Subscription } from "rxjs";
import { bufferTime } from "rxjs/operators";
import { IMqttMessage } from 'ngx-mqtt';
import { Device } from '@app/shared/sdk';

@Component({
  selector: 'app-line-chart-reactive',
  template: `
      <canvas #chart></canvas>`,
  styles: [`
      :host {
          display: inline-block;
          width: 100%;
          height: 100%;
          position: relative;
      }
  `]
})
export class LineChartReactiveComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('chart')
  private chartRef: ElementRef;
  private chart: Chart;
  @Input()
  private dataSource: Observable<Point>;
  @Input()
  private mqttEventObserve: Observable<IMqttMessage>;
  @Input()
  private deviceSerialNumber: string;
  @Input()
  private displayTitle = true;
  @Input()
  private displayLegend = true;
  @Input()
  private totalData = 50;
  @Input()
  public data = {
    current: [],
    voltage: [],
    power: []
  }
  // @Output() changeData = new EventEmitter<any>();
  private dataSourceSubscription: Subscription;
  mqttEventSubcription: Subscription;
  @Input()
  private fontSize: number;


  constructor() {
  }
  ngOnInit(): void {
    // console.log(this.data)

  }

  ngAfterViewInit() {
    this.chart = new Chart(this.chartRef.nativeElement, {
      type: 'line',
      data: {
        datasets: [
          {
            label: 'VRMS min',
            data: this.data.current,
            fill: false,
            backgroundColor: 'rgb(236, 14, 14)',
            borderColor: 'rgb(236, 14, 14)'
          },
          {
            label: 'VRMS max',
            data: this.data.voltage,
            fill: false,
            backgroundColor: 'rgb(40, 14, 236)',
            borderColor: 'rgb(40, 14, 236)'
          },
          {
            label: 'VRMS avg',
            data: this.data.power,
            fill: false,
            backgroundColor: 'rgb(221, 236, 14)',
            borderColor: 'rgb(221, 236, 14)'
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.displayLegend,
          labels: {
            fontSize: this.fontSize || 12
          }
        },
        title: {
          display: this.displayTitle,
          text: this.deviceSerialNumber
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'quarter',
              displayFormats: {
                quarter: 'HH:mm:ss',
              }
            },
            distribution: 'series'
          }],
        }
      }
    });
    this.mqttEventSubcription = this.mqttEventObserve.subscribe((message: any) => {
      let data = JSON.parse(message.payload.toString());
      if (data.payload)
        data = data.payload
      data.current = Number(data.current)
      data.power = Number(data.power)
      data.voltage = Number(data.voltage)
      if (this.deviceSerialNumber === data.deviceSerialNumber) {
        this.data.voltage.push({ x: data.date, y: data.voltage });
        this.data.current.push({ x: data.date, y: data.current });
        this.data.power.push({ x: data.date, y: data.power });

        if (this.data.voltage.length > this.totalData) {
          this.data.voltage.splice(0, this.data.voltage.length - this.totalData);
          this.data.current.splice(0, this.data.current.length - this.totalData);
          this.data.power.splice(0, this.data.power.length - this.totalData);
        }
        // this.changeData.emit(this.data)
        this.chart.update();
      }

    })
  }

  ngOnDestroy(): void {
    // this.dataSourceSubscription.unsubscribe();
    this.mqttEventSubcription.unsubscribe();
  }
}
